/* global console */

// import { fetchDocumentPartNodeWithPermissions } from "../api/document/DocumentsPart";
import { EmbeddedRoots } from "../api/models/embedded-roots";
import { DocumentRoot } from "../api/models/document-root";
import { fetchDocumentPartNodeWithPermissions } from "../api/document/DocumentsPart";

interface PromiseData {
  page: number;
  promise: () => Promise<EmbeddedRoots>;
}

interface PromiseResponse {
  page: number;
  value: DocumentRoot[];
}

if (!Promise.allSettled) {
  Promise.allSettled = function (promises) {
    return Promise.all(
      promises.map((p) =>
        p.then((value) => ({ status: "fulfilled", value })).catch((reason) => ({ status: "rejected", reason }))
      )
    );
  };
}

/*
// const fetchDocumentPartNodeWithPermissions = fakeCall;

function fakeCall(documentId: string, page: number): Promise<EmbeddedRoots> {
  const temp = documentId;
  console.log("FAKE CALL FOR page => ", page);

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (Math.random() <= 0.85 || page == 0) {
        resolve({
          _embedded: {
            content: [
              {
                hasReadPermissions: true,
                documentPart: {
                  name: "FIRST",
                  hasChildren: true,
                  id: "1234",
                  subparts: [
                    {
                      hasReadPermissions: true,
                      documentPart: {
                        name: "CHILD",
                        hasChildren: true,
                        id: "5678",
                        subparts: [
                          {
                            hasReadPermissions: true,
                            documentPart: {
                              name: "INNEST",
                              hasChildren: false,
                              id: "5678",
                              subparts: [],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
          page: {
            totalPages: 8,
            size: 20,
            totalElements: 200,
            number: page,
          },
        } as any);
      } else reject("GENERAL ERROR");
    }, 2000);
  });
}
*/

export class DocumentPartGroupFetcher {
  private readonly documentId: string;
  private remainingPages: number;

  private readonly MAX_GROUPED_PAGES = 5;
  private readonly MAX_RETRY = 2;

  private retryTracker = new Map<number, number>();

  constructor(documentId: string) {
    this.documentId = documentId;
  }

  async callChildrenInGroup(): Promise<DocumentRoot[]> {
    const data = await fetchDocumentPartNodeWithPermissions(this.documentId, 0);
    this.remainingPages = data.page.totalPages - 1;
    const firstPageData = data._embedded.content ?? [];
    if (!this.remainingPages) return firstPageData;

    let startPage = 1;
    const finalResponse: DocumentRoot[] = [...firstPageData];

    while (this.remainingPages) {
      console.log("%c ROUND CHIAMATE", "background-color: blue; color: white; font-size: 20px", this.remainingPages);

      const result = await this.callGroupedPages(startPage);
      startPage += result.length;
      this.remainingPages -= result.length;
      const orderedData = result.sort((a, b) => a.page - b.page).reduce((acc, el) => [...acc, ...el.value], []);

      finalResponse.push(...orderedData);
    }

    return finalResponse;
  }

  private createGroupCallObj(startPage: number, lastPage: number) {
    const promises: PromiseData[] = [];

    for (let page = startPage; page <= lastPage; page++) {
      const promiseObj = {
        page,
        promise: fetchDocumentPartNodeWithPermissions.bind(null, this.documentId, page),
      };
      promises.push(promiseObj);
    }
    return promises;
  }

  private async callGroupedPages(startPage: number): Promise<PromiseResponse[]> {
    const lastGroupPage = this.remainingPages < this.MAX_GROUPED_PAGES ? this.remainingPages : this.MAX_GROUPED_PAGES;
    let callsTodo: PromiseData[] = this.createGroupCallObj(startPage, startPage + (lastGroupPage - 1));

    const final: PromiseResponse[] = [];

    while (callsTodo.length) {
      const { finalData, retryCalls } = await this.groupCallsSettled(callsTodo);
      callsTodo = retryCalls;
      final.push(...finalData);
    }

    return final;
  }

  private async groupCallsSettled(promisesObj: PromiseData[]) {
    const responses = await Promise.allSettled(promisesObj.map((el) => el.promise()));
    const finalData: PromiseResponse[] = [];
    const retryCalls: PromiseData[] = [];

    for (let respIdx = 0; respIdx < responses.length; respIdx++) {
      const currentResponse = responses[respIdx]!;
      const currentPromiseObj = promisesObj[respIdx]!;
      if (currentResponse.status === "fulfilled") {
        const respObj = { page: currentPromiseObj.page, value: currentResponse.value?._embedded?.content ?? [] };
        finalData.push(respObj);
      } else {
        console.error(
          `Error calling page ${currentPromiseObj.page} of docpart for document ${this.documentId} `,
          currentResponse.reason
        );
        this.handleRetry(currentPromiseObj.page);
        retryCalls.push(currentPromiseObj);
      }
    }

    return { finalData, retryCalls };
  }

  private handleRetry(page: number) {
    const retriedTimesForCurrentPage = this.retryTracker.get(page);
    if (retriedTimesForCurrentPage === this.MAX_RETRY) throw new Error("MASSIME CHIAMATE FATTE PER LA PAGINA " + page);
    this.retryTracker.set(page, (retriedTimesForCurrentPage ?? 0) + 1);
  }
}
